import {
  Box, Button,
  Grid,
  Paper,

  Typography
} from "@material-ui/core";
import memoize from "memoize-one";
import React from "react";
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import ListableCard from "../../../components/listable-card/ListableCard";
import { Loading } from "../../../components/loading/Loading";
import PageContainer from "../../../components/page-container/PageContainer";
import GenericPickerModal from "../../../containers/generic-picker-modal/GenericPickerModal";
// Actions
import { getRoute } from "../../../state/actions/RouteActions";
import {
  assignUsersToRoute, getUsers,
  getUsersForRoute,
  GET_USER_SIZE,
  removeUsersFromRoutes,
  removeFromRoutes,
  clearUsers
} from "../../../state/actions/UserActions";
import styles from "./ViewRoutePage.module.scss";


var routeId = "";

class ViewRoutePage extends React.Component {
  constructor(props) {
    super();

    this.state = {
      loadingRoute: false,
      loadingUsersInRoute: false,
      usersInRoute: [],
      addUserModalOpen: false,
      deleteAlertShowing: false,
      usersToDelete: null,
      selectedUsers: [],
      originalData: [],
      searchedData: [],

      hasNewData: true,
      firstUserFetch: true,
      loadingUsers: false,
      lastSearch: ""
    };

    this.handleAddUsersToRoleCancel = this.handleAddUsersToRoleCancel.bind(this)
    this.handleAddUsersToRole = this.handleAddUsersToRole.bind(this)
    this.getNextPage = this.getNextPage.bind(this)
  }

  componentDidMount() {
    this.setState({ loadingRoute: true, loadingUsersInRoute: true });

    routeId = this.props.match.params.routeId;

    this.props.getRoute(routeId, () => {
      this.setState({ loadingRoute: false });
    });

    this.props.getUsersForRoute(routeId, () => {
      this.setState({ loadingUsersInRoute: false });
    });
  }

  useContinuationToken = memoize(
    (continuationToken) => continuationToken != null
  );

  navigateToUser(userInRoute) {
    this.props.history.push(`/users/${userInRoute.id}`);
  }

  deleteUserFromRoute() {
    this.props.removeUsersFromRoutes(this.state.usersToDelete, [routeId], routeId, () => {
      this.setState({ usersToDelete: null, deleteAlertShowing: false, loadingUsersInRoute: true });

      this.props.getUsersForRoute(routeId, () => {
        this.setState({ loadingUsersInRoute: false });
      });
    });
  }

  alertDialog() {
    const { t } = this.props
    const usersToDelete = this.state.usersToDelete !== null ? this.state.usersToDelete : [];
    let usersToDeleteName = "";

    if (usersToDelete.length > 0) {
      usersToDeleteName = t("route.count-users", { count: usersToDelete.length })
    } else if (usersToDelete.length === 1) {
      usersToDeleteName = usersToDelete[0];
    }

    return (
      <AlertDialog
        title={t("route.remove-users-question", { usersToDeleteName: usersToDeleteName, routeId: routeId })}
        description={t("route.remove-users-description")}
        options={[
          {
            label: t("common.cancel"),
            action: () => this.setState({ deleteAlertShowing: false })
          },
          { label: t("common.delete"), action: () => this.deleteUserFromRoute() }
        ]}
        isOpen={this.state.deleteAlertShowing}
      />
    );
  }

  addUsersToRoute(incomingUsers) {
    const updatedUsers = Object.values(this.props.assignedUsers).map(item => item.id).concat(incomingUsers)

    this.props.assignUsersToRoute(updatedUsers, routeId, () => {
      this.setState({ addUserModalOpen: false });
      this.props.getUsersForRoute(routeId, () => {
        this.setState({ loadingUsersInRoute: false });
      });
    });
  }
  handleAddUsersToRoleCancel() {
    this.setState({ addUserModalOpen: false })
  }

  handleAddUsersToRole(incomingUsers) {
    this.addUsersToRoute(incomingUsers.filter(item => this.state.usersInRoute[item] == null))
  }

  getNextPage(value = "") {
    var { lastSearch } = this.state
    var { continuationToken } = this.props

    var searchValue = value
    if (value == "" && lastSearch != "" && continuationToken?.search != null) {
      searchValue = lastSearch
    }

    if (value != "") {
      this.setState({ lastSearch: value })
    }

    let promiseResolver
    this.props.getUsers(() => {
      this.setState({ firstUserFetch: false, loadingUsers: false })

      promiseResolver()

    }, GET_USER_SIZE.LARGE, searchValue != "" ? continuationToken?.search : continuationToken?.base, searchValue, searchValue == "")

    return new Promise((resolve) => {
      this.setState({ loadingUsers: true })
      promiseResolver = resolve
    })
  }

  addUserModal() {
    const { t } = this.props
    return (
      <GenericPickerModal
        title={t("route.add-users")}
        searchTitle={t("user.users")}
        idField="id"
        valueField="name"
        open={this.state.addUserModalOpen}
        data={Object.values(this.props.users)}
        getAllData={this.getNextPage}
        handleCancel={this.handleAddUsersToRoleCancel}
        handleDone={this.handleAddUsersToRole}
        selected={Object.values(this.state.usersInRoute).map(item => item.id)}
        currentSelection={Object.values(this.state.usersInRoute).map(item => item.id)}

        infiniteLoading
        hasNextPage={this.state.hasNewData || this.state.firstUserFetch}
        isNextPageLoading={this.state.loadingUsers}
        loadNextPage={this.getNextPage}
      />
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(this.props.assignedUsers) !==
      JSON.stringify(this.state.usersInRoute)
    ) {
      this.setState({ usersInRoute: this.props.assignedUsers });
    }

    if (this.state.addUserModalOpen == false && prevState.addUserModalOpen != this.state.addUserModalOpen) {
      this.props.clearUsers(() => { })
    }

    const searchData = this.props.continuationToken?.search != null
    const baseData = this.props.continuationToken?.base != null

    const newData = prevState.hasNewData
    if (newData !== (searchData || baseData)) {
      this.setState({ hasNewData: (searchData || baseData) })
    }

    if (this.state.searchData !== prevState.searchData && !this.state.searchData) {
      this.setState({ lastSearch: "" })
    }
  }

  getContentGrid() {
    const { t } = this.props

    const usersInRoute = this.state.usersInRoute != null ? this.state.usersInRoute : [];
    return (
      <div className={styles.contentGrid}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
            <Paper>
              <ListableCard
                actionButton={[
                  <Button
                    onClick={() => this.setState({ addUserModalOpen: true })}
                    variant="outlined"
                    color="secondary"
                  >
                    {t('user.assign-user')}
                  </Button>
                ]}
                addLabel={t("route.add-user")}
                title={t("route.assigned")}
                emptyPlaceholder={t("route.no-assigned-users")}
                handleDelete={users =>
                  this.setState({
                    deleteAlertShowing: true,
                    usersToDelete: users
                  })
                }
                onClick={userId => this.props.history.push(`/users/${userId}`)}
                data={Object.values(usersInRoute).map(user => { return { id: user.id, Name: user.name } })}
              />
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }

  render() {
    const { route, t } = this.props

    if (route == null) {
      return (
        <Box>
          <Typography>
            {t("route.incorrect-data")}
          </Typography>
        </Box>
      )
    }

    const content = this.getContentGrid();

    return (
      <div>
        <BreadcrumbsItem to={`/routes/${routeId}`}>Route</BreadcrumbsItem>

        {this.addUserModal()}
        {this.alertDialog()}

        {this.state.loadingRoute ? (
          <Loading />
        ) : (
            <div>
              <HeaderBlock title={route.id} />
              <PageContainer>
                {content}
              </PageContainer>
            </div>
          )}
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { route } = state.RouteReducer;
  const { assignedUsers, users, continuationToken } = state.UserReducer;
  return { route, assignedUsers, users, continuationToken };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getRoute,
      getUsersForRoute,
      removeFromRoutes,
      getUsers,
      assignUsersToRoute,
      removeUsersFromRoutes,
      clearUsers
    },
    dispatch
  );

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ViewRoutePage))
);

// EXPORT COMPONENT

export { hoc as ViewRoutePage };
